import { API_BASE_URL } from './client';

// Notifications API
export const createNotification = async (keycloak, notificationData) => {
  if (!keycloak || !keycloak.token) throw new Error('Not authenticated');
  const response = await fetch(`${API_BASE_URL}/notifications/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${keycloak.token}`,
    },
    body: JSON.stringify(notificationData),
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || 'Failed to create notification');
  }
  return response.json();
};

export const getNotifications = async (keycloak, dismissed = null, limit = 100) => {
  if (!keycloak || !keycloak.token) throw new Error('Not authenticated');
  const params = new URLSearchParams();
  if (dismissed !== null) params.append('dismissed', dismissed.toString());
  params.append('limit', limit.toString());
  const response = await fetch(`${API_BASE_URL}/notifications/?${params.toString()}`, {
    headers: {
      'Authorization': `Bearer ${keycloak.token}`,
    },
  });
  if (!response.ok) throw new Error('Failed to fetch notifications');
  return response.json();
};

export const updateNotification = async (keycloak, notificationId, updates) => {
  if (!keycloak || !keycloak.token) throw new Error('Not authenticated');
  const response = await fetch(`${API_BASE_URL}/notifications/${notificationId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${keycloak.token}`,
    },
    body: JSON.stringify(updates),
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || 'Failed to update notification');
  }
  return response.json();
};

export const dismissNotification = async (keycloak, notificationId) => {
  if (!keycloak || !keycloak.token) throw new Error('Not authenticated');
  const response = await fetch(`${API_BASE_URL}/notifications/${notificationId}/dismiss`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${keycloak.token}`,
    },
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || 'Failed to dismiss notification');
  }
  return response.json();
};

export const deleteNotification = async (keycloak, notificationId) => {
  if (!keycloak || !keycloak.token) throw new Error('Not authenticated');
  const response = await fetch(`${API_BASE_URL}/notifications/${notificationId}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${keycloak.token}`,
    },
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || 'Failed to delete notification');
  }
};

export const clearAllNotifications = async (keycloak) => {
  if (!keycloak || !keycloak.token) throw new Error('Not authenticated');
  const response = await fetch(`${API_BASE_URL}/notifications/`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${keycloak.token}`,
    },
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || 'Failed to clear notifications');
  }
};